import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface SendGymMessageParams {
  gymId: string;
  content: string;
}

export const useSendGymMessage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ gymId, content }: SendGymMessageParams) => {
      const { data: userData, error: userError } = await supabase.auth.getUser();
      if (userError || !userData.user) {
        throw new Error("No estás autenticado");
      }

      const { error } = await supabase.from("gym_messages").insert({
        gym_id: gymId,
        user_id: userData.user.id,
        content: content.trim(),
      });

      if (error) throw error;
    },
    onSuccess: () => {
      toast.success("Mensaje enviado al gimnasio");
      queryClient.invalidateQueries({ queryKey: ["my-gym-messages"] });
    },
    onError: (error: Error) => {
      toast.error(error.message || "No se pudo enviar el mensaje");
    },
  });
};
